/* eslint-disable complexity */
/* eslint max-params: ["error", 5] */

import './analysis.scss';
import React, {Component} from 'react';
import {findKeyValuePair, findValueKeyPair} from '../../../../../shared/services/rga-utils';
import {FormattedMessage} from 'react-intl';
import InlineAlertBar from '../../../../../../shared/components/inline-alert-bar';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import LabeledKeyValueDropDown from '../../../../../../claim/shared/components/claim-fields/labeled-key-value-dropdown';
import LabeledTextArea from '../../../../../../claim/shared/components/claim-fields/labeled-text-area';
import PropTypes from 'prop-types';
import RgaAdditionalDataInfo from '../../../../../rga-search-results/state/rga-additional-data-info';
import RgaDetails from '../../../../../rga-search-results/state/rga-details';
import Security from '@deere/cps-it.warranty-model-factory/lib/security';
import WarrantyLoadingIndicator from '../../../../../../shared/components/warranty-loading-indicator';

function onChangeAdditionalDataFieldValue(props, field, event) {

    props.actions.updateRgaAdditionalDataCommentsValues(this, props.additionalDataInfo, event, field);

}

function onChangeAdditionalDataParamFieldValue(props, field, event) {

    props.actions.updateRgaAdditionalDataCommentsValues(this, props.additionalDataInfo, event.target.value, field);

}

function onChangeAdditionalDataTypeDropDownValue(props, event) {

    props.actions.updateRgaAdditionalDataTypeValues(props.rgaDetails, event.target.value);

}

function onChangeAdditionalDataTestDropDownValue(props, event) {

    const testDataType = findValueKeyPair(props.additionalDataTest, event.target.value);

    props.actions.updateRgaAdditionalDataTestValues(props.additionalDataInfo.dataParameters, testDataType);

}
function onSave() {

    this.props.actions.postRgaAdditionalDataValues(this.props.additionalDataInfo, this.state.isUpdate);

}

function onCancel() {

    this.actions.getRgaDetails(this.rgaDetails);

}
class AdditionalData extends Component {

    constructor(props) {

        super(props);
        this.state = {
            isUpdate: false
        };

    }

    componentWillMount() {

        if (this.props.rgaDetails.responsibleUnit) {

            this.props.actions.getAdditionalDataType(this.props.rgaDetails.responsibleUnit);
            this.props.actions.getAdditionalTestParameter(this.props.rgaDetails.responsibleUnit);

        }

        if (this.props.rgaDetails.rgaNumber && this.props.rgaDetails.responsibleUnit) {

            this.props.actions.getAdditionalData(this.props.rgaDetails.rgaNumber, this.props.rgaDetails.responsibleUnit);

        }

        if (this.props.additionalDataInfo.dataType !== null) {

            this.setState({isUpdate: true});

        }

    }

    render() {

        const {rgaDetails} = this.props;

        return (
            rgaDetails && this.props.rgaDetails.responsibleUnit !== '' ?
                <section className='rga-recalled-form'>
                    <WarrantyLoadingIndicator isLoading={this.props.busyCounter > 0}/>
                    <div className='row'>
                        <LabeledKeyValueDropDown
                            className={'additional-data-rgaunit-dropdown'}
                            isEditable={true}
                            isValid={true}
                            label='Unit'
                            list={this.props.rgaUnits}
                            onChange={null}
                            selectedValue={findValueKeyPair(this.props.rgaUnits, rgaDetails.responsibleUnit)}
                            tabIndex='1'
                        />
                        {this.props.security.role === 'RGA_USER' ?
                            <LabeledKeyValueDropDown
                                className={'additional-data-rgaunit-dropdown'}
                                isEditable={true}
                                isValid={true}
                                label='Data Types'
                                list={this.props.additionalDataType}
                                onChange={onChangeAdditionalDataTypeDropDownValue.bind(event, this.props)}
                                selectedValue={this.props.additionalDataInfo.dataType ? this.props.additionalDataInfo.dataType : {key: '', value: ''}}
                                tabIndex='2'
                            /> :
                                <LabeledKeyValueDropDown
                                    className={this.props.additionalDataFlag ? 'additional-data-rgaunit-dropdown' : 'additional-data-dropdown'}
                                    isEditable={true}
                                    isValid={true}
                                    label='Data Types'
                                    list={this.props.additionalDataType}
                                    onChange={onChangeAdditionalDataTypeDropDownValue.bind(event, this.props)}
                                    selectedValue={this.props.additionalDataInfo.dataType ? this.props.additionalDataInfo.dataType : {key: '', value: ''}}
                                    tabIndex='2'
                                /> }
                    </div>
                    {this.props.additionalDataInfo.dataType &&
                    <div>
                        <div className='row'>
                            <h3 className='section-title'>
                                {'Data Type :'} {this.props.additionalDataInfo.dataType.value}
                            </h3>
                        </div>
                        <div
                            className='row'
                            style={{marginBottom: '20px'}}
                        ></div>
                        {this.props.additionalDataInfo.dataParameters.map((item, index) => (
                                       item.dataTypeId === 'ZTEST' ?
                                           <div
                                               className='row'
                                               key={index}
                                           >
                                               <LabeledKeyValueDropDown
                                                   className={this.props.security.role === 'RGA_USER' ? 'additional-data-rgaunit-dropdown' : 'additional-data-dropdown'}
                                                   isEditable={true}
                                                   isValid={true}
                                                   label='Test Results'
                                                   list={this.props.additionalDataTest}
                                                   onChange={onChangeAdditionalDataTestDropDownValue.bind(event, this.props)}
                                                   selectedValue={findKeyValuePair(this.props.additionalDataTest, this.props.additionalDataInfo.testData.value)}
                                                   tabIndex='16'
                                               />
                                               <LabeledTextArea
                                                   className={this.props.security.role === 'RGA_USER' ? 'additional-data-rgaunit-dropdown' : 'additional-data-dropdown'}
                                                   isEditable={true}
                                                   label='Comments'
                                                   onChange={onChangeAdditionalDataFieldValue.bind(item, this.props, 'paramComments')}
                                                   tabIndex='22'
                                                   value={item.paramComments}
                                               />
                                           </div> : null))}
                        <div className='row parameter-grid'>
                            <table className='parameter-table'>
                                <thead>
                                    <tr>
                                        <th><FormattedMessage id='Parameter Name'/></th>
                                        <th><FormattedMessage id='Value'/></th>
                                        <th><FormattedMessage id='Comments'/></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.props.additionalDataInfo.dataParameters.map((item, index) => (
                                       item.dataTypeId === 'ZTEST' ? null : <tr key={index}>
                                           <td>{item.paramName}{item.paramType === '' ? item.paramType : <sub>{'('}{item.paramType}{')'}</sub> }</td>
                                           <td>
                                               {this.props.security.role === 'RGA_USER' ?
                                                   item.paramValue :
                                                   <input
                                                       onChange={onChangeAdditionalDataParamFieldValue.bind(item, this.props, 'paramValue')}
                                                       placeholder={`Enter ${item.paramType} Value`}
                                                       type='text'
                                                       value={item.paramValue === null ? '' : item.paramValue}
                                                   />}
                                           </td>
                                           <td>
                                               {this.props.security.role === 'RGA_USER' ?
                                                       item.paramComments :
                                                       <input
                                                           onChange={onChangeAdditionalDataParamFieldValue.bind(item, this.props, 'paramComments')}
                                                           placeholder='Enter Comments'
                                                           type='text'
                                                           value={item.paramComments === null ? '' : item.paramComments}
                                                       />}
                                           </td>
                                       </tr>
                            ))}
                                </tbody>
                            </table>
                        </div>
                        <section className='button-group recalled-button-group'>
                            <button
                                className='secondary'
                                onClick={onCancel.bind(this.props)}
                            >
                                <FormattedMessage id='CANCEL'/>
                            </button>
                            <button
                                className='primary'
                                disabled={this.props.security.role === 'RGA_USER'}
                                onClick={onSave.bind(this)}
                            >
                                <FormattedMessage id='SAVE'/>
                            </button>
                        </section>
                    </div>
                    }
                </section> :
                <InlineAlertBar
                    className='additional-data-alert-bar'
                    label='The Responsible Unit field is currently blank in the Analysis tab. Please update it to proceed.'
                    type='warning'
                />

        );

    }
}

AdditionalData.displayName = 'AdditionalData';
AdditionalData.propTypes = {
    actions: PropTypes.object.isRequired,
    additionalDataFlag: PropTypes.bool.isRequired,
    additionalDataInfo: PropTypes.instanceOf(RgaAdditionalDataInfo).isRequired,
    additionalDataTest: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    additionalDataType: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    busyCounter: PropTypes.number.isRequired,
    rgaDetails: PropTypes.instanceOf(RgaDetails).isRequired,
    rgaUnits: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    security: PropTypes.instanceOf(Security).isRequired
};

export default AdditionalData;



// WEBPACK FOOTER //
// ./src/rga/recalled-part-analysis/components/returned-part-information/recalled-part-tab/components/additional-data.js